import { api } from "../../services/NetworkBase";

export async function GetEnviroTestKits() {
	try {
		let response = await api
			.get(`vlp/enviro-test-kits`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}


export async function UpdateEnviroTestKit(kit) {
	try {
	  let response = await api.put("vlp/enviro-test-kits", { json: kit });
	  return response;
	} catch (error) {
	  throw error;
	}
  }
  
  export async function SaveEnviroTestKit(kit) {
	try {
	  let response = await api.post("vlp/enviro-test-kits", {
		json: kit,
	  });
	  return response;
	} catch (error) {
	  throw error;
	}
  }

  export async function DeleteEnviroTestKit(kitId) {
	try {
	  const encodedUrl = encodeURIComponent(kitId);
	  let response = await api
		.delete(`vlp/enviro-test-kits/${encodedUrl}`)
		.json();
	  return response;
	} catch (error) {
	  throw error;
	}
  }





